// components/ui/ItemDetailsModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ItemDetailsModal = ({
    show,
    onHide,
    itemData, // The selected item from history
    renderItemDetailsContent, // (itemData) => JSX for the modal body
    modalTitle = "Details"
}) => {
    if (!itemData) return null;

    return (
        <Modal show={show} onHide={onHide} size="xl" centered scrollable>
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {renderItemDetailsContent(itemData)}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ItemDetailsModal;